import { TieredPrice } from "@omni/types/api/product/bff/shared/tieredPrice.model";
import { CloudTieredPrice } from "@omni/types/api/product/cloud/shared/tieredPrice.model";
import { AlgoliaSearchTieredPrice } from "@omni/types/api/search/algolia/product/shared/tieredPrice.model";
import { BffSearchTieredPrice } from "@omni/types/api/search/bff/product/shared/tieredPrice.model";
import { ModelMapper } from "@omni/types/utils/modelMapper";

const fromCloudToBff: ModelMapper<CloudTieredPrice, TieredPrice> = (model) => {
    return {
        quantity: model.quantity,
        price: model.price
    };
};

const fromAlgoliaSearchToBff: ModelMapper<
    AlgoliaSearchTieredPrice,
    TieredPrice
> = (model) => {
    return {
        quantity: model.quantity,
        price: model.price
    };
};

const fromAlgoliaSearchToBffSearch: ModelMapper<
    AlgoliaSearchTieredPrice,
    BffSearchTieredPrice
> = (model) => {
    return {
        quantity: model.quantity,
        price: model.price
    };
};

const fromBffSearchToBff: ModelMapper<BffSearchTieredPrice, TieredPrice> = (
    model
) => {
    return {
        quantity: model.quantity,
        price: model.price
    };
};

const fromBffSearchToAlgoliaSearch: ModelMapper<
    BffSearchTieredPrice,
    AlgoliaSearchTieredPrice
> = (model) => {
    return {
        quantity: model.quantity,
        price: model.price
    };
};

const fromBffToAlgoliaSearch: ModelMapper<
    TieredPrice,
    AlgoliaSearchTieredPrice
> = (model) => {
    return {
        quantity: model.quantity,
        price: model.price
    };
};

const fromBffToBffSearch: ModelMapper<TieredPrice, BffSearchTieredPrice> = (
    model
) => {
    return {
        quantity: model.quantity,
        price: model.price
    };
};

export const TieredPriceMapper = {
    fromCloudToBff: fromCloudToBff,
    fromAlgoliaSearchToBff: fromAlgoliaSearchToBff,
    fromAlgoliaSearchToBffSearch: fromAlgoliaSearchToBffSearch,
    fromBffSearchToBff: fromBffSearchToBff,
    fromBffSearchToAlgoliaSearch: fromBffSearchToAlgoliaSearch,
    fromBffToAlgoliaSearch: fromBffToAlgoliaSearch,
    fromBffToBffSearch: fromBffToBffSearch
};
